/**
 * Layout model
 */
export default class LayoutModel {
  /**
   * Class constructor method
   * @param id
   * @param lid
   * @param mby
   * @param mon
   * @param n
   * @param s
   * @param w
   * @param d
   */
  constructor({ id = 0, lid = '', mby = '', mon = '', n = '', s = '', w = '', d = false }) {
    /**
     * Database id
     * @type {number}
     */
    this.id = id;
    /**
     * Layout id
     * @type {string}
     */
    this.layoutId = lid;
    /**
     * Modified by name
     * @type {string}
     */
    this.modifiedBy = mby;
    /**
     * Modified on
     * @type {string}
     */
    this.modifiedOn = mon;
    /**
     * Layout name
     * @type {string}
     */
    this.name = n ? n.toLowerCase() : '';
    /**
     * Settings object
     * @type {any}
     */
    this.settings = JSON.parse(s);
    /**
     * Widgets object
     * @type {any}
     */
    this.widgets = JSON.parse(w);
    /**
     * Is layout default
     * @type {boolean}
     */
    this.default = d;
  }
}
